import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { SACRAMENTS } from '../data/mock';
import { PageHeader } from './MassTimes';

const Sacraments = () => {
  return (
    <>
      <PageHeader
        eyebrow="Encountering Christ"
        title="The Seven Sacraments"
        subtitle="The sacraments are efficacious signs of grace, instituted by Christ and entrusted to the Church, by which divine life is dispensed to us."
      />

      <section className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 gap-6">
          {SACRAMENTS.map(s => (
            <Link
              key={s.slug}
              to={`/sacraments/${s.slug}`}
              className="group flex items-start gap-5 bg-white border border-[#e9e0cc] hover:border-[#3a2359] p-7 hover:shadow-sm"
            >
              <div className="flex-shrink-0 w-14 h-14 rounded-full bg-[#f2ead6] flex items-center justify-center font-display text-2xl text-[#3a2359] group-hover:bg-[#3a2359] group-hover:text-[#e6d4a8]">
                {s.title.charAt(0)}
              </div>
              <div className="flex-1">
                <h2 className="font-display text-2xl text-[#2a1a45] mb-2">{s.title}</h2>
                <p className="text-sm text-[#5a534a] leading-relaxed mb-3">{s.description}</p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-[#3a2359] group-hover:gap-2">
                  Learn more <ChevronRight size={14} />
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-14 text-center bg-[#f2ead6]/50 border border-[#e9e0cc] p-10">
          <h3 className="font-display text-2xl md:text-3xl text-[#2a1a45] mb-3">Preparing for a Sacrament?</h3>
          <p className="text-[#5a534a] mb-6 max-w-2xl mx-auto">
            For scheduling, preparation, and questions about any sacrament, please contact the parish office. Our clergy would be happy to walk with you.
          </p>
          <Link to="/contact" className="inline-block px-6 py-3 bg-[#3a2359] text-white text-sm tracking-wide hover:bg-[#4d2f75]">
            Contact the Parish Office
          </Link>
        </div>
      </section>
    </>
  );
};

export default Sacraments;
